import * as React from 'react';
import { withRouter } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import Button from '../../components/Button/Button';
import LinkButton from '../../components/Button/LinkButton';
const styles = require('./Wizard.less') as any;

import { connect } from 'react-redux';
import get from 'lodash/get';
const mapStateToProps = (state, ownProps) => ({
    profile: get(state, 'profile.data')
});
@connect(mapStateToProps)
class Wizard extends React.Component<any,any> {
		render() {
				const { children, profile, router } = this.props;
        if (!children) router.replace(`/wizard/${get(profile, 'completion', 0)+1}`);
				return <div style={{'display': 'flex', 'justifyContent': 'center'}}>{children}</div>;
		}
}

export default withRouter(Wizard);



// WEBPACK FOOTER //
// ./src/app/containers/Wizard/Wizard.tsx